import { ReactNode, useRef, useState } from "react";
import Popover from "../PopoverRc";
import "./index.less";
import ArrowUpIcon from "@/assets/common/ic_arrow_up.svg";
import ArrowDownIcon from "@/assets/common/ic_arrow_down.svg";
import RightIcon from "@/assets/common/ic_right.svg";

// TODO: 类型推断
export interface IOption {
  label: ReactNode;
  selectLabel?: ReactNode;
  value: string | number;
  hide?: boolean;
}

interface RSelectProps {
  disabled?: boolean;
  options: IOption[];
  value: string| number;
  placement?: "top" | "topRight" | "bottom" | "bottomRight" | "bottomLeft";
  title?: React.ReactElement;
  downIcon?: React.ReactNode;
  upIcon?: React.ReactNode;
  contentStyleWidth?: string;
  selectContentClassName?: string;
  align?: {
    offset: [number, number];
  };
  onChange: (value: string| number) => void;
}

const RSelect = (props: RSelectProps) => {
  const { disabled = false, options, value, placement, title, downIcon, upIcon, contentStyleWidth, selectContentClassName, onChange, align } = props;
  const [visible, setVisible] = useState(false);

  const selectWrapRef = useRef<HTMLDivElement>(null);

  return (
    <div className="select-wrap" ref={selectWrapRef}>
      <Popover
        destroyTooltipOnHide
        hover={false}
        placement={placement || "top"}
        onVisibleChange={(newVisible)=>{
          if(!disabled){
            setVisible(newVisible);
          }
        }}
        visible={visible}
        className="select-popover"
        content={
          <div
            className="options-content"
            style={{
              width: contentStyleWidth || selectWrapRef.current?.clientWidth,
            }}
          >
            {title}
            {options.filter(item=>!item.hide).map((item) => {
              return (
                <div
                  key={item.value}
                  className={`options-item ${item.value === value ? "active" : ""}`}
                  onClick={() => {
                    onChange(item.value);
                    setVisible(false);
                  }}
                >
                  <div className="label">{item.label}</div>
                  {item.value === value ? <img src={RightIcon} className="choose-icon" /> : <div className="choose-icon"></div>}
                </div>
              );
            })}
          </div>
        }
        align={align || {
          offset: [0, 5],
        }}
      >
        <div className={`select-content ${disabled ? 'disabled': ''} ${selectContentClassName}`}>
          <div className="select-value">{options.find((item) => item.value === value)?.selectLabel || options.find((item) => item.value === value)?.label}</div>
          {disabled ? null : visible ? (upIcon || <img className="icon" src={ArrowUpIcon} />) : (downIcon || <img className="icon" src={ArrowDownIcon} />)}
        </div>
      </Popover>
    </div>
  );
};

export default RSelect;
